import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getCurrentProduct,
  getDaysSinceStartSale,
  getFilteredViewedProducts,
  getNbSubUniversesInCatalog,
  getNbUniversesInCatalog,
  getOperationCode,
  getProductCallPrice,
  getProductPriceValue,
  getSaleStartTime,
  getSubUniverseNameExcludingAllProducts,
  getUniverseNameExcludingAllProducts
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, state) => {
  const product = getCurrentProduct(state)
  const nbUniverses = getNbUniversesInCatalog(state)

  return {
    '# of Recently Viewed Product Displayed': getFilteredViewedProducts(state).length,
    '# of Sub Universes': getNbSubUniversesInCatalog(state),
    '# of Universes': nbUniverses > 1 ? nbUniverses : 0,
    'Click Name': 'Click cancel conditions popup',
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Event Name': eventName,
    'Lowest Product Price': getProductCallPrice(state),
    'Operation Code': getOperationCode(state),
    'Page Name': 'Product Page',
    'Product': product.content.title,
    'Product ID': product.ecomm.externalId,
    'Product Price': getProductPriceValue(state),
    'Sale Start Time': getSaleStartTime(state),
    'Stock Status': product.outOfStock ? 'Not Available' : 'Available',
    'Under Universe': getSubUniverseNameExcludingAllProducts(state),
    'Universe': getUniverseNameExcludingAllProducts(state)
  }
}

const clickCancellationPoliciesEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.product.ON_CANCELLATION_POLICIES_CLICK),
  tap(action => {
    const eventName = 'Click'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickCancellationPoliciesEpic
